/* =========================================================
   TIMELINE
========================================================= */

import React from "react";
import SectionHeader from "./SectionHeader";

const TimelineSection = ({ data }) => (
    <section className="timeline-section" id="about">

        <div className="container">

            <SectionHeader
                title={data.title}
                description={data.description}
            />

            <div className="timeline">

                {(data.items || []).map((item, i) => (
                    <div className="timeline-item" key={i}>

                        <div className="timeline-year">
                            {item.year}
                        </div>

                        <div>
                            <h3>{item.title}</h3>
                            <p>{item.description}</p>
                        </div>

                    </div>
                ))}

            </div>

            <div className="timeline-action">
                <a
                    href="/rect/html/about"
                    className="timeline-btn timeline-btn-primary"
                >
                    About STEMX365
                    <span>→</span>
                </a>

                <a
                    href="/rect/founder"
                    className="timeline-btn"
                >
                    Our Journey
                    <span>→</span>
                </a>

                {/* <a
                    href="/rect/html/advisor"
                    className="timeline-btn"
                >
                    Our Advisors
                    <span>→</span>
                </a> */}
            </div>

        </div>

    </section>
);

export default TimelineSection;